<template lang="pug">
.close-button-container.w-full.flex.justify-center.items-center()
  .screen-exit-button.group(:class="smallDevice && 'w-full'")
    uc-button.btn.btn-primary.unlock.ripple.mx-auto(
      :class="[smallDevice && 'w-full', !props.isNested && 'fade-in', props.isNested && '!opacity-100']"
      data-sfx="complete-course"
      @click="exitCourse"
      :disabled="hasSessionEnded"
    )
      uc-text(
        k="Complete the course"
        text="Complete the course"
      )
.close-message-container.w-full.flex.justify-center.items-center(v-if="showMessage")
  .screen-exit-message.text-center.border-radius.border-b-secondary-500.transition.opacity-0.bg-paper.p-6(
    :class="hasSessionEnded && 'opacity-90'"
  )
    uc-text.text-xl.editable.editable--prose.prose(
      k="Thank you for completing the course! {r} If the window does not automatically close, please close it manually."
      text="Thank you for completing the course!\n\n If the window does not automatically close, please close it manually."
    )
</template>

<script setup lang="ts">
import { inject, ref, nextTick } from 'vue';
import getConfetti from '../lib/getConfetti';
import { stop } from '../lib/audio';
import { setExit, setSessionTime, set, saveSuspendData } from '../lib/SCORM';
import colors from 'tailwindcss/colors';
import useContent from '../stores/useContent';
import { storeToRefs } from 'pinia';
import useSuspend from '../lib/useSuspend';

const props = defineProps<{
  isNested?: boolean;
}>();

const suspend = useSuspend();
const hasSessionEnded = ref(false);
const showMessage = ref(false);

const { compiled: content } = storeToRefs(useContent());

const emit = defineEmits(['exit']);

const smallDevice = inject('smallDevice', false);

const exitCourse = (event: MouseEvent) => {
  console.log('Exit course - course complete button');
  // suspend data tracking for support
  set('complete-button', true);
  saveSuspendData();
  stop();
  setSessionTime();
  nextTick(() => {
    setExit();
    emit('exit');
  });

  hasSessionEnded.value = true;
  showMessage.value = true;

  // no confetti if reduced motion
  if (suspend.reducedMotion) return;

  // create the confetti colours
  const primaryColors = colors[content.value?.course?.primary] ?? colors.blue;
  const secondaryColors =
    colors[content.value?.course?.secondary] ?? colors.yellow;
  const colours = [
    primaryColors[300],
    primaryColors[500],
    primaryColors[800],
    secondaryColors[300],
    secondaryColors[500],
    secondaryColors[800]
  ];
  const buttonEl = event.target as HTMLButtonElement;
  if (buttonEl) getConfetti(buttonEl, colours, 90);
};
</script>
